import axios from 'axios';
import FollowButton from 'components/category/show/FollowButton';
import { formatDate, secondsToDuration } from 'components/category/show/utility';
import CustomPopup from 'components/shared/modal/customPopup';
import React, { useEffect, useState } from 'react'
import _ from "lodash";
import { baseUrl } from 'api/constants';
import { decryptData } from 'utils/encryption';
import { getCookie } from 'utils/cookieHelper';

function MoreEpisodes({ postData, seriesSlug = '', size }) {

  const [episodes, setEpisodes] = useState(null)
  const [seriesData, setSeriesData] = useState(null)
  const [loginPrompt, setLoginPrompt] = useState(false)

  const [hasMore, setHasMore] = useState(true);
  const [skipPerPage, setSkipPerPage] = useState(2);



  const getMorePost1 = _.debounce(async () => {
    const res = await fetch(
      `${baseUrl}/series/series-details?postSlug=${seriesData?.postSlug}&limit=10&skip=${isNaN(skipPerPage) ? "2" : skipPerPage
      } `
    );
    const newPosts = await res.json();
    // setPosts((post) => [...post, ...newPosts?.result?.series?.episodes]);
    setEpisodes((episodes) => [...episodes, ...newPosts?.result?.series?.episodes]);
    setSkipPerPage((skip) => skip + 1);
    if (!newPosts?.result?.series?.episodes?.length) {
      setHasMore(false);
    }
  }, 1000);

  useEffect(() => {
    if (!seriesSlug) return;

    let bearerToken = null
    try {
      const cookie = JSON.parse(decodeURIComponent(getCookie('lallantop')))
      const token = decryptData(cookie?.encryptedToken)
      bearerToken = token

    } catch (error) {
      console.error('API error:', error);
      bearerToken = null
    }
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.NEXT_PUBLIC_APP_API_URL}/v1/series/series-details`,
          {
            params: {
              postSlug: seriesSlug,
              limit: 10,
              skip: 1,
            },
            headers: {
              ...(bearerToken && { Authorization: `Bearer ${bearerToken}` }), // replace with your token variable
            },
          }

        );
        // console.log(res.data);
        setEpisodes(res?.data?.result?.series?.episodes)
        setSeriesData(res?.data?.result?.series)
      } catch (err) {
        console.error('API error:', err);
        setEpisodes(null)
        setSeriesData(null)
      }
    };

    fetchData();



  }, [seriesSlug]);

  const handleClick = (data) => {
    window.location.href = data?.permalink?.split(".com")[1]
  }


  return (
    <>
      {(episodes && episodes?.length > 0) ?
        <div className="rounded-4 bg-white " style={{marginTop: "15px" }}>
          <div className=''>
            <div className="d-flex p-2 justify-content-between align-items-center">
              <div style={{ width: "145px", heigh: "51px" }} className=''>
                <img src={seriesData?.headingImageUrl + "?width=200"} alt="playlist_img" className='w-100 h-100 rounded-4'></img>
              </div>

              <div className="d-flex gap-2 align-items-center">
                <div className="d-flex gap-8 flex-column align-items-end">
                  {/* <p className="m-0 p-0" style={{ fontSize: "14px", fontWeight: 600, color: 'rgba(235, 14, 140, 1)' }}>FOLLOW</p> */}
                  {seriesData && <FollowButton show={seriesData} size={size} setLoginPrompt={setLoginPrompt} />}
                  <p className="m-0 p-0" style={{ fontSize: "16px", fontWeight: 400, color: 'rgba(134, 134, 134, 1)' }}>{seriesData?.episodesCount} एपिसोड्स</p>
                </div>
                {/* <svg width="35" height="30" viewBox="0 0 21 20" fill={"none"} xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.95633 0.00146484H15.1177C18.4563 0.00146484 20.3612 1.88677 20.3612 5.23514V14.4063C20.3612 17.7351 18.4661 19.64 15.1275 19.64H5.95633C2.60796 19.64 0.722656 17.7351 0.722656 14.4063V5.23514C0.722656 1.88677 2.60796 0.00146484 5.95633 0.00146484ZM11.3464 10.6359H14.135C14.5867 10.6261 14.95 10.2627 14.95 9.81105C14.95 9.35937 14.5867 8.99605 14.135 8.99605H11.3464V6.22702C11.3464 5.77533 10.983 5.41202 10.5314 5.41202C10.0797 5.41202 9.71635 5.77533 9.71635 6.22702V8.99605H6.9375C6.72147 8.99605 6.51527 9.08443 6.35816 9.23172C6.21087 9.38883 6.1225 9.59405 6.1225 9.81105C6.1225 10.2627 6.48581 10.6261 6.9375 10.6359H9.71635V13.4147C9.71635 13.8664 10.0797 14.2297 10.5314 14.2297C10.983 14.2297 11.3464 13.8664 11.3464 13.4147V10.6359Z" fill={"rgba(235, 14, 140, 1)"} />
                </svg> */}
              </div>
            </div>

            <div className="p-2 mt-2" style={{ backgroundColor: "rgba(235, 14, 140, 1)" }}>
              <p className="m-0 p-0 " style={{ fontWeight: 400, fontSize: "15.77px", color: "rgba(255, 255, 255, 1)" }}>अन्य एपिसोड्स</p>
            </div>
          </div>

          <div onScroll={getMorePost1}  style={{ maxHeight: "800px", overflowY: "auto", }}>
            {episodes?.map((episode, ind) => (

              <div onClick={() => handleClick(episode)} key={ind} className="d-flex justify-content-between gap-2 align-items-start p-2" style={{ flexDirection: size?.width < 700 ? "row-reverse" : "initial", backgroundColor: episode?._id == postData?._id ? "rgba(235, 14, 140, 0.1)" : "white", cursor: "pointer" }}>
                <div>
                  <p className="m-0 p-0" style={{ fontWeight: 600, fontSize: "15px", width: "fit-content", maxWidth: "240px" }}>
                    {episode?.title}
                  </p>
                  <p className="m-0 p-0" style={{ fontSize: "14px", fontWeight: "400", color: "#999999" }}>
                    <svg className='me-1' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.63536 1.97327C12.4102 1.97327 15.4714 5.03376 15.4714 8.80931C15.4714 12.5849 12.4102 15.6453 8.63536 15.6453C4.85981 15.6453 1.79932 12.5849 1.79932 8.80931C1.79932 5.03376 4.85981 1.97327 8.63536 1.97327Z" stroke={"#999999"} stroke-width="1.43917" stroke-linecap="round" stroke-linejoin="round" />
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7942 8.80583C10.7942 8.22215 7.80256 6.35491 7.46319 6.69065C7.12382 7.02639 7.09119 10.5536 7.46319 10.921C7.83519 11.2897 10.7942 9.38951 10.7942 8.80583Z" stroke={"#999999"} stroke-width="1.43917" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    {/* 01:15:00
                    <span className='mx-0'>{"   |  "}</span> 1 day ago */}
                    {secondsToDuration(episode?.duration)}  <span className='mx-0'>{"   |  "}</span> {formatDate(episode?.publishedAt)}
                  </p>

                </div>
                <div style={{ maxWidth: "200px", minWidth: "120px", height: "70" }} className='rounded-4 border'>
                  {/* <img src={'http://localhost:4000/assets/images/thumbnail.png'} className='w-100 h-100 rounded-4' style={{ objectFit: "cover" }}></img> */}
                  <img src={episode?.headingImageUrl + "?width=200"} className='rounded-4' style={{ objectFit: "cover", widthc: "163px", height: "auto" }}></img>
                </div>
              </div>
            ))}
          </div>

          <CustomPopup
            showModal={loginPrompt}
            onClose={() => setLoginPrompt(false)}
          />

        </div> : null}
    </>
  )
}

export default MoreEpisodes
